// What the mapmaking submission check decided, as a value: only
// preventSubmission blocks the mapmaker. Everything else — geometry warnings,
// the robot-path advisory, a failed /path/simulate — is listed and then asks
// for confirmation.
export type SubmissionCheckOutcome = 'ok' | 'confirm' | 'block';

export function submissionCheckOutcome(preventSubmission: boolean, errors: unknown[]): SubmissionCheckOutcome {
  if (preventSubmission) {
    return 'block';
  }

  return errors.length > 0 ? 'confirm' : 'ok';
}
